// src/components/common/Notification/Notification.jsx
import React, { useEffect, useState } from 'react';
import styles from './Notification.module.css';
import {
    IoCheckmarkCircleOutline,
    IoCloseCircleOutline,
    IoAlertCircleOutline // Можно использовать для warning или общей ошибки
} from 'react-icons/io5';

const NOTIFICATION_TIMEOUT = 4000; // 4 секунды до автозакрытия

const Notification = ({ id, message, type = 'info', onDismiss }) => {
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsExiting(true);
        }, NOTIFICATION_TIMEOUT);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (isExiting) {
            // Даем время на анимацию исчезновения перед фактическим удалением
            const exitTimer = setTimeout(() => {
                onDismiss(id);
            }, 500); // Должно совпадать с длительностью CSS-анимации выхода
            return () => clearTimeout(exitTimer);
        }
    }, [isExiting, id, onDismiss]);

    const Icon = {
        success: IoCheckmarkCircleOutline,
        error: IoCloseCircleOutline,
        warning: IoAlertCircleOutline,
        info: IoAlertCircleOutline, // По умолчанию
    }[type];

    return (
        <div
            className={`${styles.notification} ${styles[type]} ${isExiting ? styles.exiting : styles.entering}`}
            role="alert"
        >
            {Icon && <Icon className={styles.icon} />}
            <span className={styles.message}>{message}</span>
            <button onClick={() => setIsExiting(true)} className={styles.closeButton} aria-label="Dismiss notification">
                &times; {/* Простой крестик для закрытия */}
            </button>
        </div>
    );
};

export default Notification;
